import React from 'react'
import Products from './Products'
import MainBanner from '../components/MainBanner'



export default function Main() {
  return (
    <div>

  <MainBanner/>
   <Products />
    
    </div>
  )
}
